import React from "react";
import ModalDisplay from "./ModalDisplay";
import Div from "../../components/common/Div";
import { tenzero } from "../../constants/Constants";
import Text from "../../components/common/Text";
import ModalButton from "../../components/common/ModalButton";
import { Typography } from "@mui/material";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";

export default function SuccessfulRegistrationBox(props) {
  var displayValue = "none";
  if (props.display) displayValue = "block";

  return (
    <ModalDisplay display={displayValue}>
      <div style={iconContainerStyle}>
        <CheckCircleIcon style={successIconStyle} />
      </div>
      <Div margin={tenzero}>
        <Typography
          fontWeight={"bold"}
          color={"rgb(33, 42, 65)"}
          style={{ fontSize: "1.25rem", textAlign: "center" }}
        >
          Registration Successful
        </Typography>
      </Div>
      <Div margin={tenzero}>
        <Text color={"rgb(33, 42, 65)"} fontSize={"0.9rem"}>
          You have successfully registered. Please log in to continue.
        </Text>
      </Div>
      <Div margin={tenzero}>
        <ModalButton onClick={props.handler}>Close</ModalButton>
      </Div>
    </ModalDisplay>
  );
}
const iconContainerStyle = {
  display: "flex",
  width: "fit-content",
  justifyContent: "center",
  marginBottom: "15px",
  backgroundColor: "rgb(33, 42, 65, 0.3)",
  borderRadius: "20%",
  padding: "10px",
  margin: "0 auto",
};

const successIconStyle = {
  color: "rgb(33, 42, 65)",
  fontSize: "2rem",
};
